import React, { useEffect, useRef } from 'react'
import { Button } from 'carbon-components-react'
import PropTypes from 'prop-types'
import { MFA } from '../MFASteps'
import { trackEventMessage } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_GET_STARTED } from '../../../constants'

export const AskMeAgain = ( { onGetStartedClick, onAskMeAgainClick, webId } ) => {
    
    const headerReference = useRef( null )

    const handleGetStartedClick = () => { 
        trackEventMessage( new EventModel( MFA_GET_STARTED.GET_STARTED, webId ) )
        onGetStartedClick()
    }

    const handleOnAskMeAgainClick = ( factor ) => { 
        trackEventMessage( new EventModel( MFA_GET_STARTED.ASK_ME_AGAIN_LATER, webId ) )
        onAskMeAgainClick( factor )
    }
    
    useEffect( () => {
            headerReference?.current?.focus() 
    }, [] 
    )

  return (
      <main role="main" className="c-main">
          <div className="os-container--max-width">
              <div className="c-mfa-card">
                  <div className="c-mfa-card__container">
                      <div className='mb-6'><header ref={ headerReference } tabIndex='0' className='c-mfa-label--title' aria-label={ MFA.AskMeAgain.title }>{ MFA.AskMeAgain.title }</header></div>
                      <div className='mb-7'><p tabIndex='0' className='c-mfa-label--content' aria-label={ MFA.AskMeAgain.description }> { MFA.AskMeAgain.description } </p></div>
                      <Button id='dt-mfa-getstarted' className={ 'c-btn c-btn--primary mb-5' } type="button" aria-label={ `${ MFA.AskMeAgain.getStarted } Enabled ` } name= { MFA.AskMeAgain.getStarted } onClick={ handleGetStartedClick } data-testid="btn-getStarted">{ MFA.AskMeAgain.getStarted }</Button>
                      <Button id='dt-mfa-askmeagainlater' className={ 'c-btn c-btn--tertiary' } onClick={ handleOnAskMeAgainClick } aria-label= { `${ MFA.AskMeAgain.askMeAgainLater } Enabled ` } name= {  MFA.AskMeAgain.askMeAgainLater  } type='button' data-testid="btn-askMeAgain"> {  MFA.AskMeAgain.askMeAgainLater  } </Button>
                  </div>
              </div>
          </div>
      </main>
  )
}

AskMeAgain.propTypes = {
    onGetStartedClick: PropTypes.func,
    onAskMeAgainClick: PropTypes.func,
    webId: PropTypes.string
}